<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="Resolsnap">
          <div class="content-panel1" v-show="IsSlaErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ slatype }} SLA</h2>
            <apiErrorComponent @tryReload="tryReload" compTitle="SLA" compId="Resolsnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IsSlaErr" :class="{ 'contblinking': iskeysla }">
            <div class="insideL  hide-on-presentation " :class="isHovered ? 'showL' : ''">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IsSlaErr">
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()"
                    :title="isShowTable ? 'Hide Table' : 'Show Table'" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                  <span class="myLeftHover" v-on:mouseenter="isHovered = true" v-show="funcCrt.length">
                    <font-awesome-icon icon="fa-solid fa-magnifying-glass-chart" title="Explain Trend" />
                  </span>
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.slainfo }} You can click on individual bars to get more
                insights.<br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" /> to see table with
                    values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to
                    storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart
                    with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download
                    all the
                    insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isSLALoaded">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div class="infoLeftHover" v-show="isHovered" v-on:mouseleave="isHovered = false">
              <div v-for="(value, index) in funcCrt" :key="index" class="cursor-pointer">
                <span v-on:click="explainModel(value)">{{ value.split('~')[1] }}</span>
              </div>
            </div>
            <div v-show="isSLALoaded"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ slatype }} SLA</h2>
            <div class="panel-body text-center" :class="{ 'BlurClass': IsSlaErr }">
              <div class="chartHeightControl" style="margin-top:-10px;">
                <div id="resslaChart" v-show="IsSlaShow"></div>
              </div>
              <div v-if="isShowTable">
                <div v-on:click="onBtnExport()" class="myfaBtn spl">
                  <font-awesome-icon :icon="['fas', 'fa-download']" />
                </div>
                <ag-grid-vue style="width: 96%;height:470px;"
                  class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
                  @grid-ready="onAsgReady" :modules="modules">
                </ag-grid-vue>
              </div>
              <div v-if="IsSladata" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
            <widgetsSlider :insideArr="slainsight" :isInsErr="IsSlaInsErr" :isErr="IsSlaErr" compTitle="SLA"
              compId="Resolsnap"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var myChartSLA, chartDomSLA;
function reportWindowSizeSLA() {
  if (myChartSLA != undefined) {
    chartDomSLA.style.width = (document.getElementById('Resolsnap').clientWidth - 50) + "px";
    myChartSLA.resize()
  }
}
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import {
  CsvExportModule
} from "@ag-grid-community/csv-export";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue';
import widgetsSlider from '../smallcomp/widgets-slider.vue';
import widgetExplainData from "./../../mixin/wiExplainLink";
export default {
  name: 'SLATrend',
  mixins: [screenShotMix, widgetExplainData],
  components: {
    widgetDataMsg,
    widgetLoadingComp,
    AgGridVue,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      modules: [ClientSideRowModelModule, CsvExportModule],
      asgLisApi: null,
      asgLis: null,
      asgcolsDefs: [],
      isShowTable: false,
      isSLALoaded: false,
      IsSladata: false,
      IsSlaShow: false,
      IsSlaErr: true,
      IsSlaInsErr: false,
      iskeysla: false,
      slatype: "",
      slainsight: [],
      screenShort: {
        id: 'Resolsnap',
        name: 'Resolsnap.png'
      },
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      isChartRedraw: true,
      funcCrt: [],
      isHovered: false,
    }
  },
  methods: {
    explainModel(currpass) {
      var emit = this.$emit
      emit("explainModel", currpass)
    },
    genrateExplainLink() {
      this.funcCrt = []
      this.funcCrt = this.widgetExplain(this.slainsight)
    },
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getSLA(this.getwgtCond)
    },
    addToSlider() {
      let insArr = this.slainsight;
      this.isHovered = false
      let name = this.slatype + " SLA Trend - " + this.getPins.viewName;
      let screenShort = {
        id: 'Resolsnap',
        name: 'Resolsnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    onAsgReady(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.asgLis);
      params.api.sizeColumnsToFit();
    },
    onBtnExport() {
      this.asgLisApi.exportDataAsCsv();
    },
    percGetter(params, c, d, e, f) {
      return params.data["SLAViolation"] + '%'
    },
    myIdxComparator(v1, v2, n1, n2) {
      return n1.data.Index - n2.data.Index
    },
    myPercComparator(v1, v2, n1, n2) {
      v1 = parseFloat(v1.slice(0, -1))
      v2 = parseFloat(v2.slice(0, -1))
      return v1 - v2
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        this.asgcolsDefs = [{
          headerName: 'Month',
          field: 'Mnth',
          sortable: true,
          comparator: this.myIdxComparator,
        },
        {
          headerName: 'SLA Violation %',
          field: 'SLAViolation',
          sortable: true,
          comparator: this.myPercComparator,
          valueGetter: this.percGetter,
        },
        {
          headerName: 'Exceeded SLA',
          field: 'ExceededSLA',
          type: 'numericColumn',
          sortable: true
        },
        {
          headerName: 'Within SLA',
          field: 'WithinSLA',
          type: 'numericColumn',
          sortable: true
        }
        ]
        this.isShowTable = true;
      }
    },
    downloadDom() {
      this.isHovered = false
      let imgname = this.slatype + "_SLA" + ".png"
      let widgetID = "Resolsnap"
      var geticondiv = document.querySelectorAll('#Resolsnap .insideL,#Resolsnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = this.slatype + '_SLA' + '_Insights.txt'
      let insArr
      insArr = this.slainsight.join("\r\n")
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    drawSLA(slawholedata) {
      var emit = this.$emit
      chartDomSLA = document.getElementById('resslaChart');
      if(chartDomSLA == null) return;
      if (chartDomSLA != null && chartDomSLA != undefined) {
        chartDomSLA.style.height = "375px"
        chartDomSLA.style.width = (document.getElementById('Resolsnap').clientWidth - 50) + "px";
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartSLA = echarts.init(chartDomSLA);
        }
        let optionSLA = {
          tooltip: {
            confine: true,
            trigger: 'axis',
          },
          legend: {
            type: 'scroll',
            textStyle: {
              color: "inherit"
            }
          },
          grid: {
            left: 0,
            top: 70,
            right: '3%',
            bottom: 20,
            containLabel: true
          },
          toolbox: {
            top: 0,
            right: 20,
            itemSize: 20,
            iconStyle: {
              borderColor: '#777'
            },
            feature: {
              magicType: {
                type: ['stack']
              },
              restore: {
                show: true
              },
            }
          },
          xAxis: [{
            type: 'category',
            data: slawholedata.Labels,
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
          }],
          yAxis: [{
            type: 'value',
            name: '# Tickets',
            nameTextStyle: {
              fontSize: 10,
              color: "#777"
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
          },
          {
            type: 'value',
            name: 'SLA Violation %',
            nameTextStyle: {
              fontSize: 10,
              color: "#777"
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              color: "#777",
              fontSize: 10,
              formatter: function (value, index) {
                return value + '%';
              }
            },
          }
          ],
          series: [{
            name: 'Exceeded SLA',
            type: 'bar',
            data: slawholedata.Bardata1,
            groupID: "g1",
            stack: "g1",
            itemStyle: {
              borderRadius: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(253, 55, 56, 1.0)'
              }, {
                offset: 1,
                color: 'rgba(253, 55, 56, 0.4)'
              }]),
              borderColor: 'rgb(253, 55, 56)',
              borderWidth: 1,
              opacity: 1
            },
          },
          {
            name: 'Within SLA',
            type: 'bar',
            data: slawholedata.Bardata2,
            groupID: "g1",
            stack: "g1",
            itemStyle: {
              borderRadius: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(54, 191, 54, 1.0)'
              }, {
                offset: 1,
                color: 'rgba(54, 191, 54, 0.4)'
              }]),
              borderColor: 'rgb(54, 191, 54)',
              borderWidth: 1,
              opacity: 1
            }
          },
          {
            name: 'SLA Violation %',
            type: 'line',
            groupID: "g2",
            stack: "g2",
            symbolSize: 8,
            symbol: 'circle',
            yAxisIndex: 1,
            itemStyle: {
              color: "rgba(184, 0, 0, 0.75)"
            },
            tooltip: {
              confine: true,
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: slawholedata.linedata
          }
          ]
        };
        myChartSLA.setOption(optionSLA);
        myChartSLA.on('click', function (params) {
          if (params.componentType === 'series' && params.data != undefined) {
            let clickitem = {
              "currpass": params.seriesName + "~" + params.name,
              "filterop": "SLA"
            }
            emit("getKDrill", clickitem)
          }
        })
      }
    },
    getSLA(urlval) {
      var url
      this.isSLALoaded = false
      this.IsSladata = false
      this.IsSlaShow = false
      this.IsSlaInsErr = false
      this.IsSlaErr = false
      if (urlval == 3) {
        url = "DataAnalysis/resolutioninsightsview?asg_id="
        this.slatype = "Resolution"
      } else {
        url = "DataAnalysis/responseinsightsview?asg_id="
        this.slatype = "Response"
      }
      this.axios.post(this.uriApiUrl + url + this.asgId, {
        "get_prior": this.getPins.get_prior,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              var slawholedata = response.data
              this.slainsight = slawholedata.insights
              for (let i = 0; i < this.slainsight.length; i++) {
                this.slainsight[i] = this.slainsight[i].replace(/\|/g, '').replace(/~/g, '')
              }
              this.genrateExplainLink()
              this.IsSlaShow = true
              if (this.slainsight.length == 0) {
                this.IsSlaInsErr = true
              }
              this.asgLis = [];
              for (let i = 0; i < slawholedata.Bardata1.length; i++) {
                var eleT = {
                  "Index": i,
                  "Mnth": slawholedata.Labels[i],
                  "ExceededSLA": slawholedata.Bardata1[i],
                  "WithinSLA": slawholedata.Bardata2[i],
                  "SLAViolation": slawholedata.linedata[i]
                }
                this.asgLis.push(eleT)
              }
              if (this.isChartRedraw) {
                try {
                  echarts.dispose(myChartSLA);
                } catch (error) {
                  // console.log("..")
                }
              }
              this.drawSLA(slawholedata)
            } else if (response.data == "Nodata") {
              this.IsSladata = true
            } else {
              this.IsSlaErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Sla Trend. Try after sometime!'
              })
            }
            this.isSLALoaded = true
          }
        }).catch((response) => {
          this.IsSlaErr = true
          this.isSLALoaded = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Sla Trend. Try after sometime!'
            })
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getSLA(this.getwgtCond)
    this.isChartRedraw = true
    window.addEventListener("resize", reportWindowSizeSLA);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeSLA);
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    },
    getgradGreen() {
      return this.$store.getters.getgradGreen
    },
    getgradRed() {
      return this.$store.getters.getgradRed
    },
  },
  watch: {
    getPins() {
      this.getSLA(this.getwgtCond)
    },
    getpass() {
      this.getSLA(this.getwgtCond)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>